import { opt } from 'store/opt'

export type Gender = 'female' | 'male'

export type SkinIndex = 1 | 2 | 3 | 4 | 5
export type BodyIndex = 1 | 2 | 3 | 4 | 5
export type BustIndex = 1 | 2 | 3 | 4

export enum ShapeType {
  APPLE = 'apple',
  HOURGLASS = 'hourglass',
  INVERTED_TRIANGLE = 'inverted triangle',
  OVAL = 'oval',
  PEAR = 'pear',
  RECTANGLE = 'rectangle',
  TRIANGLE = 'triangle',
}

export enum BodyThickness {
  SKINNY = 'skinny',
  SLIM = 'slim',
  NORMAL = 'normal',
  CURVY = 'curvy',
  PLUS_SIZE = 'plus_size',
}

export enum IdentityMode {
  BASE = 0,
  EXTENDED = 1,
  DETAILED = 2,
  SIMPLE = 3,
}

export type IdentitiesRequest = {
  user_id: string
}

export type ExtendedShapeJson = {
  shape_type: ShapeType
  height: string
  legLength: number
  body_thickness: BodyThickness,
}

export type DimensionsJson = {
  height: number
  shoulders: number
  chest: number
  waist: number
  hips: number
  legLength: number
}

export type BaseIdentityRequest = {
  gender: Gender
  skin_index?: SkinIndex
  face1_url: string | undefined
  face2_url?: string | undefined
  user_url?: string | undefined
  body1_url?: string | undefined
  identity_mode: IdentityMode
  body?: BodyIndex
  breasts?: BustIndex
  extended_shape?: string
  dimensions?: string
  pic_change?: number
  image_desc?: string | null
}

export type IdentityRequest = BaseIdentityRequest & {
  user_id: string
}

export type CreateIdentityRequest = IdentityRequest

export type UpdateIdentityRequest = IdentityRequest & {
  identity_id: string
}

export type CreateIdentityResponse = {
  identity_id: string
}

export type ExtendedShape = {
  height?: string
  legLength?: number
  shape_type?: ShapeType
  body_thickness?: BodyThickness
}

type IdentityDimensions = {
  hips?: number
  chest?: number
  waist?: number
  height?: number
  shoulders?: number
  legLength?: number
}

export type Identity = {
  user_id: string
  identity_id: string
  face1_url?: string
  face2_url?: string
  user_url?: string
  body1_url?: string
  body_index: BodyIndex
  skin_index: SkinIndex
  breast_index: BustIndex
  gender: Gender
  identity_mode: IdentityMode
  extended_shape: ExtendedShape
  dimensions: IdentityDimensions
}

type MinMaxDef = {
  min: number
  def: number
  max: number
}

const shoulders: Record<string, MinMaxDef | undefined> = {
  male: { min: 40, def: 42, max: 60 },
  female: { min: 30, def: 36, max: 50 },
}

export function getShouldersConfig(gender: string): MinMaxDef {
  const def = opt.options.gender || 'female'
  return shoulders[gender] || shoulders[def] || shoulders['female']!
}

export function buildIdentityUpdate(identity_id: string, request: IdentityRequest): Record<string, unknown> {
  const { user_id, face1_url, face2_url, user_url, body1_url } = request
  return { user_id, identity_id, face1_url, face2_url, user_url, body1_url }
}
